import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService, MediaApi, MediaItem } from '@mtgame/core';

@Injectable({providedIn: 'root'})
export class GameMediaService extends BaseService {
  private gameId: number;

  get media$(): Observable<MediaItem[]> {
    return this.store.get('media');
  }

  constructor(
    private mediaApi: MediaApi
  ) {
    super();
  }

  async initialize(gameId: number): Promise<any> {
    this.gameId = gameId;
    return await this.getMedia();
  }

  async getMedia(): Promise<MediaItem[]> {
    const media = await this.mediaApi.getGameMedia(this.gameId);
    this.store.save('media', media);
    return media;
  }
}
